'use strict'

const formatter = new Intl.NumberFormat('de-DE');
import Simulator from './Simulator';

class Planificador extends Simulator {
    
    constructor() {
        super();
        this.setOptions({
            monthly_savings:0,
            worked_years:0,
            salary:20000,
            actividad_bonificada: 'Actividad No Bonificada',
            giro_actividad: 'DIC',
            sexo: 'M',
            es_trabajador_nuevo: false,
            fecha_nacimiento: '',
            cantidad_hijos: 0,
            densidad_cotizacion: '1.0',
            escenario_renta_aseguradora: 'BASE',
        });
        this.options_tmp = Object.assign({}, this.options);
    }

    formControlDisable(disable){
        $.var('jubilacion_bps_years').text('...');
        $.var('jubilacion_bps_con_art_8').text('...');
        $.var('jubilacion_bps_sin_art_8').text('...');
        $.var('jubilacion_regimen_de_ahorro_years').text('...');
        $.var('jubilacion_regimen_de_ahorro_con_art_8').text('...');
        $.var('jubilacion_regimen_de_ahorro_sin_art_8').text('...');
        
        $('input[name="sexo"]').prop('disabled', disable);
        $('input[name="cantidad_hijos"]').prop('disabled', disable);
        $('select[name="giro_actividad"]').prop('disabled', disable).selectric('refresh');
        $('select[name="actividad_bonificada"]').prop('disabled', disable).selectric('refresh');
        $('select[name="densidad_cotizacion"]').prop('disabled', disable).selectric('refresh');
        $('input[name="monthly_savings"]').prop('disabled', disable);
        $('input[name="worked_years"]').prop('disabled', disable);
        $('input[name="salary"]').prop('disabled', disable);
        $('input[name="age"]').prop('disabled', disable);
    }

    init () {
        $('input[name="sexo"]').on('change', () => {
            this.options_tmp.sexo = $('input[name="sexo"]').is(':checked') ? 'F' : 'M';
        });
        $('select[name="actividad_bonificada"]').on('change', (e) => {
            e.preventDefault();
            this.options_tmp.actividad_bonificada = $(e.currentTarget).val();
        });
        $('select[name="giro_actividad"]').on('change', (e) => {
            e.preventDefault();
            this.options_tmp.giro_actividad = $(e.currentTarget).val();
        });
        $('select[name="children"]').on('change', (e) => {
            e.preventDefault();
            this.options_tmp.children = $(e.currentTarget).val();
        });
        $('select[name="densidad_cotizacion"]').on('change', (e) => {
            e.preventDefault();
            this.options_tmp.densidad_cotizacion = $(e.currentTarget).val();
        });
        $('input[name="worked_years"]').on('change', () => {
            this.options_tmp.worked_years = parseInt($('input[name="worked_years"]').val());
        });
        $('input[name="salary"]').on('change', () => {
            this.options_tmp.salary = parseInt($('input[name="salary"]').val());
        });
        $('input[name="age"]').on('change', () => {
            this.options_tmp.age_range.from = parseInt($('input[name="age"]').val());
        });
        $('input[name="monthly_savings"]').on('change', () => {
            this.options_tmp.monthly_savings = parseInt($('input[name="monthly_savings"]').val());
        });

        $('#btn_planificador').on('click', () => {
            $('#btn_planificador').text('Enviar...');
            this.setOptions({
                age_range:{
                    from:0,
                    to:0
                },
                monthly_savings:-1,
                worked_years:-1,
                salary:-1,
                actividad_bonificada: '',
                giro_actividad: '',
                sexo: '',
                children: '',
                densidad_cotizacion: '',
                saldo_acumulado: $('input[name="saldo_acumulado"]').val()
            });
            this.load(this.options_tmp);
        });
        
        $("#simViewMore").on('click', function(e) {
            e.preventDefault();
    
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).text('Ver más');
                $("#viewMoreContent").slideUp();
            } else {
                $(this).addClass('active');
                $(this).text('Ver menos');
                $("#viewMoreContent").slideDown();
            }
        });

        this.load(this.options);
    }

    render (data, options) {
        $('#btn_planificador').text('Enviar');
        let p = parseInt((options.monthly_savings * 10 ) / (options.salary / 10));
        let jubilacion_regimen_de_ahorro = false;
        let jubilacion_bps = false;
        this.simulator_graph.data.map(function (doc){
            if(jubilacion_bps === false && (doc.jubilacion_bps_con_art_8 || doc.jubilacion_bps_sin_art_8)){
                $.var('jubilacion_bps_years').text('').text(doc.edad);
                $.var('jubilacion_bps_con_art_8').text(formatter.format(doc.jubilacion_total_con_art_8 + doc.ahorro_voluntarios[p].jubilacion_regimen_de_ahorro_por_av));
                $.var('jubilacion_bps_sin_art_8').text(formatter.format(doc.jubilacion_total_sin_art_8 + doc.ahorro_voluntarios[p].jubilacion_regimen_de_ahorro_por_av));
                jubilacion_bps = true;
            }
            if(jubilacion_regimen_de_ahorro === false && doc.edad === 65 && (doc.jubilacion_total_con_art_8 || doc.jubilacion_total_sin_art_8)){
                $.var('jubilacion_regimen_de_ahorro_years').text('').text(doc.edad);
                $.var('jubilacion_regimen_de_ahorro_con_art_8').text(formatter.format(doc.jubilacion_total_con_art_8 + doc.ahorro_voluntarios[p].jubilacion_regimen_de_ahorro_por_av));
                $.var('jubilacion_regimen_de_ahorro_sin_art_8').text(formatter.format(doc.jubilacion_total_sin_art_8 + doc.ahorro_voluntarios[p].jubilacion_regimen_de_ahorro_por_av));
                jubilacion_regimen_de_ahorro = true;
            }
        });
    }
}

export default Planificador;